function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createTheme, inputClasses, ThemeProvider } from "@mui/material";
import merge from "@mui/system/merge";
import { useGetWhiteLabel } from "@portal-middleware/hooks";
import { memo, useMemo } from "react";
export var palette = {
    alert: {
        contrastText: '#FFFFFF',
        main: '#F58645'
    },
    aliceBlue: {
        contrastText: '#0D0400',
        main: '#F2FBFF'
    },
    apple: {
        contrastText: '#FFFFFF',
        main: '#E68888'
    },
    ash: {
        contrastText: '#FFFFFF',
        main: '#DBE0E7'
    },
    azureishWhite: {
        contrastText: '#241007',
        main: '#DBEFF8'
    },
    black: {
        contrastText: '#FFFFFF',
        main: '#000000'
    },
    blister: {
        contrastText: '#FFFFFF',
        main: '#DEB304'
    },
    bloodOrange: {
        contrastText: '#FFFFFF',
        main: '#EC6517'
    },
    blueIvy: {
        contrastText: '#FFFFFF',
        main: '#3092CB'
    },
    blueSapphire: {
        contrastText: '#FFFFFF',
        main: '#0B5A80'
    },
    brandyButter: {
        contrastText: '#FFFFFF',
        main: '#F4B98F'
    },
    cherry: {
        contrastText: '#FFFFFF',
        main: '#C52C48'
    },
    cornflowerBlue: {
        contrastText: '#FFFFFF',
        main: '#7D62EC'
    },
    darkBlue: {
        contrastText: '#FFFFFF',
        main: '#123561'
    },
    darkGold: {
        contrastText: '#FFFFFF',
        main: '#7C6A20'
    },
    denim: {
        contrastText: '#FFFFFF',
        main: '#2C8FC5'
    },
    dijon: {
        contrastText: '#FFFFFF',
        main: '#DDC04A'
    },
    disabled: {
        contrastText: '#000000',
        main: '#959595'
    },
    emphasize: {
        contrastText: '#FFFFFF',
        main: '#033952'
    },
    error: {
        contrastText: '#FFFFFF',
        main: '#C00A2B'
    },
    ghostWhite: {
        contrastText: '#241007',
        main: '#F5FBFF'
    },
    grey: {
        100: '#4F4F4F',
        200: '#6B6B6B',
        300: '#737373',
        400: '#919191',
        50: '#333333',
        500: '#BDBDBD',
        600: '#E0E0E0',
        700: '#F2F2F2',
        800: '#F5F5F5',
        900: '#FAFAFA'
    },
    grey100: {
        main: '#4F4F4F'
    },
    grey200: {
        main: '#6B6B6B'
    },
    grey300: {
        main: '#737373'
    },
    grey400: {
        main: '#919191'
    },
    grey50: {
        main: '#333333'
    },
    grey500: {
        main: '#BDBDBD'
    },
    grey600: {
        main: '#E0E0E0'
    },
    grey700: {
        main: '#F2F2F2'
    },
    grey800: {
        main: '#F5F5F5'
    },
    grey900: {
        main: '#FAFAFA'
    },
    imgPlaceholder: {
        contrastText: '#000000',
        main: '#F5F5F5'
    },
    info: {
        contrastText: '#FFFFFF',
        main: '#0C78AB'
    },
    interact: {
        contrastText: '#FFFFFF',
        dark: '#005E90',
        main: '#0679af'
    },
    khaki: {
        contrastText: '#000000',
        main: '#D9D4C1'
    },
    lightBlue: {
        contrastText: '#FFFFFF',
        main: '#77B8E6'
    },
    lightGold: {
        contrastText: '#FFFFFF',
        main: '#E8D377'
    },
    lightKhaki: {
        contrastText: '#000000',
        main: '#F4F2ED'
    },
    lightestGray: {
        contrastText: '#FFFFFF',
        main: '#959595'
    },
    limeGreen: {
        contrastText: '#FFFFFF',
        main: '#2CA01C'
    },
    mahogany: {
        contrastText: '#FFFFFF',
        main: '#B64200'
    },
    malibu: {
        contrastText: '#FFFFFF',
        main: '#72C6FE'
    },
    mediumBlue: {
        contrastText: '#FFFFFF',
        main: '#3574A7'
    },
    mediumGold: {
        contrastText: '#FFFFFF',
        main: '#C3AD4D'
    },
    metallicBlue: {
        contrastText: '#FFFFFF',
        main: '#1F5670'
    },
    mint: {
        contrastText: '#FFFFFF',
        main: '#88E6C4'
    },
    muck: {
        contrastText: '#FFFFFF',
        main: '#105B41'
    },
    niceBlue: {
        contrastText: '#FFFFFF',
        main: '#0678AC'
    },
    oceanGreen: {
        contrastText: '#FFFFFF',
        main: '#39CC97'
    },
    oxfordBlue: {
        contrastText: '#FFFFFF',
        main: '#033952'
    },
    page: {
        contrastText: '#000000',
        main: '#FAFAFA'
    },
    paleSalmon: {
        contrastText: '#FFFFFF',
        main: '#F4B98F'
    },
    pictonBlue: {
        contrastText: '#FFFFFF',
        main: '#53ACE3'
    },
    pine: {
        contrastText: '#FFFFFF',
        main: '#45DCA6'
    },
    placeholder: {
        contrastText: '#FFFFFF',
        main: '#6B6B6B'
    },
    plantation: {
        contrastText: '#FFFFFF',
        main: '#285849'
    },
    primary: {
        dark: '#005E90',
        main: '#0679af'
    },
    regalBlue: {
        contrastText: '#FFFFFF',
        main: '#004574'
    },
    ruby: {
        contrastText: '#FFFFFF',
        main: '#F2526F'
    },
    seasick: {
        contrastText: '#000000',
        main: '#DEF9EA'
    },
    secondary: {
        main: '#19855F'
    },
    sky: {
        contrastText: '#FFFFFF',
        main: '#88CAE6'
    },
    slate: {
        contrastText: '#FFFFFF',
        main: '#6F889C'
    },
    spinach: {
        contrastText: '#FFFFFF',
        main: '#19855F'
    },
    success: {
        contrastText: '#FFFFFF',
        main: '#098056'
    },
    vividBurgundy: {
        contrastText: '#FFFFFF',
        main: '#9A142C'
    },
    warning: {
        contrastText: '#FFFFFF',
        main: '#CB4A00'
    },
    water: {
        contrastText: '#1F5670',
        main: '#DCF1FA'
    },
    wheat: {
        contrastText: '#FFFFFF',
        main: '#EEDD93'
    },
    white: {
        contrastText: '#000000',
        main: '#FFFFFF'
    },
    wintersDay: {
        contrastText: '#0D0400',
        main: '#DFF4FF'
    }
};
export var theme = createTheme({
    components: {
        MuiAlert: {
            defaultProps: {
                'data-component': 'alert'
            },
            styleOverrides: {
                message: {
                    '& a': {
                        color: palette.black.main,
                        textDecoration: 'underline'
                    },
                    '& button.MuiButton-inline': {
                        color: palette.black.main,
                        textDecoration: 'underline'
                    }
                },
                root: {
                    borderRadius: '7px',
                    color: palette.grey50.main,
                    fontSize: '0.875rem',
                    lineHeight: 1.5,
                    marginTop: '1rem',
                    padding: '1rem auto',
                    //the same as navbar
                    zIndex: 120
                }
            }
        },
        MuiAutocomplete: {
            defaultProps: {
                'data-component': 'autocomplete'
            },
            styleOverrides: {
                input: function(param) {
                    var theme = param.theme;
                    return {
                        padding: theme.spacing(1, 2)
                    };
                }
            }
        },
        MuiAvatar: {
            defaultProps: {
                'data-component': 'avatar'
            }
        },
        MuiBottomNavigation: {
            styleOverrides: {
                root: {
                    boxShadow: '0 0 #0000, 0 0 #0000, 0px 0px 10px #72727226',
                    height: 64
                }
            }
        },
        MuiBottomNavigationAction: {
            defaultProps: {
                focusRipple: false
            },
            styleOverrides: {
                root: {
                    color: palette.black.main,
                    height: '4rem',
                    maxWidth: 'unset',
                    minWidth: 'unset',
                    padding: 0
                }
            }
        },
        MuiButton: {
            defaultProps: {
                disableFocusRipple: true
            },
            styleOverrides: {
                contained: {
                    boxShadow: 'none',
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    lineHeight: '1.5',
                    paddingLeft: '1rem',
                    paddingRight: '1rem'
                },
                inline: {
                    '&:hover': {
                        backgroundColor: 'transparent'
                    },
                    fontWeight: 700,
                    lineHeight: 'inherit',
                    minWidth: 0,
                    padding: 0,
                    width: 'fit-content'
                },
                outlined: function(param) {
                    var ownerState = param.ownerState, theme = param.theme;
                    var _theme_palette_ownerState_color;
                    return {
                        border: "1px solid ".concat(((_theme_palette_ownerState_color = theme.palette[ownerState.color]) === null || _theme_palette_ownerState_color === void 0 ? void 0 : _theme_palette_ownerState_color.main) || theme.palette.primary.main),
                        fontSize: '0.875rem',
                        fontWeight: 700,
                        lineHeight: '1.5',
                        paddingLeft: '1rem',
                        paddingRight: '1rem'
                    };
                },
                root: function(param) {
                    var ownerState = param.ownerState, theme = param.theme;
                    var _theme_palette_ownerState_color;
                    return {
                        '& .MuiCircularProgress-root': {
                            color: theme.palette.primary.main
                        },
                        '&.Mui-disabled': {
                            backgroundColor: palette.grey700.main,
                            borderColor: palette.grey600.main,
                            color: palette.grey300.main
                        },
                        '&:focus-visible': {
                            outline: "1px solid ".concat(((_theme_palette_ownerState_color = theme.palette[ownerState.color]) === null || _theme_palette_ownerState_color === void 0 ? void 0 : _theme_palette_ownerState_color.main) || theme.palette.primary.main),
                            outlineOffset: '2px'
                        },
                        borderRadius: '0.375rem',
                        borderWidth: 1,
                        fontSize: '0.875rem',
                        fontWeight: 700,
                        lineHeight: '1.5',
                        marginBottom: 0,
                        textTransform: 'unset'
                    };
                },
                text: {
                    fontWeight: 700,
                    lineHeight: '1.5',
                    paddingLeft: '1rem',
                    paddingRight: '1rem'
                }
            }
        },
        MuiButtonGroup: {
            defaultProps: {
                disableFocusRipple: true
            }
        },
        MuiCard: {
            defaultProps: {
                'data-component': 'card'
            },
            styleOverrides: {
                root: {
                    borderRadius: '0.5rem',
                    padding: '16px'
                }
            }
        },
        MuiCardContent: {
            defaultProps: {
                'data-component': 'cardContent'
            },
            styleOverrides: {
                root: {
                    '&:last-child': {
                        paddingBottom: 0
                    },
                    padding: 0
                }
            }
        },
        MuiCardHeader: {
            defaultProps: {
                'data-component': 'cardHeader'
            },
            styleOverrides: {
                root: {
                    paddingLeft: 0,
                    paddingRight: 0,
                    paddingTop: 0
                }
            }
        },
        MuiCheckbox: {
            defaultProps: {
                disableFocusRipple: true
            },
            styleOverrides: {
                root: function(param) {
                    var ownerState = param.ownerState, theme = param.theme;
                    var _theme_palette_ownerState_color;
                    return {
                        '&.Mui-focusVisible': {
                            outline: "1px solid ".concat(((_theme_palette_ownerState_color = theme.palette[ownerState.color]) === null || _theme_palette_ownerState_color === void 0 ? void 0 : _theme_palette_ownerState_color.main) || theme.palette.primary.main),
                            outlineOffset: '2px'
                        },
                        borderRadius: '5px',
                        margin: '0 9px',
                        padding: 0
                    };
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: function(theme) {
                return {
                    '.bg-primary': {
                        backgroundColor: theme.palette.primary.main
                    },
                    '.border-primary': {
                        borderColor: theme.palette.primary.main
                    },
                    //TODO: return to it once Form is refactored
                    '.contents': {
                        display: 'contents'
                    },
                    '.list-disc': {
                        listStyleType: 'disc'
                    },
                    '.list-inside': {
                        listStylePosition: 'inside'
                    },
                    '.list-outside': {
                        listStylePosition: 'outside'
                    },
                    '.sr-only': {
                        borderWidth: 0,
                        clip: 'rect(0, 0, 0, 0)',
                        height: '1px',
                        margin: '-1px',
                        overflow: 'hidden',
                        padding: 0,
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '.text-primary': {
                        color: theme.palette.primary.main
                    },
                    'a:focus-visible': {
                        borderRadius: '5px',
                        outline: "1px solid ".concat(theme.palette.primary.main),
                        outlineOffset: '2px'
                    },
                    'a:not(.MuiButtonBase-root)': {
                        fontWeight: 700
                    }
                };
            }
        },
        MuiDataGrid: {
            defaultProps: {
                'data-component': 'dataGrid'
            },
            styleOverrides: {
                cell: function(param) {
                    var theme = param.theme;
                    return {
                        '&[aria-invalid="true"].MuiDataGrid-cell--editing:focus-within': {
                            outline: 'none'
                        },
                        '&[aria-invalid="true"].MuiDataGrid-withBorderColor': {
                            // todo:: find a way to better blend this into the palette
                            backgroundColor: '#FEF8FF',
                            border: "solid ".concat(theme.palette.error.main, " 1px"),
                            outline: 'none'
                        }
                    };
                },
                editInputCell: function(param) {
                    var theme = param.theme;
                    return {
                        '& input': {
                            color: theme.palette.primary.main,
                            fontSize: 'initial',
                            padding: theme.spacing(0, 1)
                        },
                        height: '100%',
                        margin: 0
                    };
                },
                overlayWrapperInner: {
                    display: 'flex',
                    flexDirection: 'column'
                },
                root: function(param) {
                    var theme = param.theme;
                    return {
                        '& .MuiDataGrid-cell': {
                            fontSize: '1rem',
                            padding: '0.25rem'
                        },
                        '& .MuiDataGrid-cell--editable': {
                            cursor: 'cell'
                        },
                        '& .MuiDataGrid-cell--editable > input': {
                            padding: '0.25rem !important'
                        },
                        '& .MuiDataGrid-cell--textRight.MuiDataGrid-cell--editable > input': {
                            textAlign: 'right'
                        },
                        '& .MuiDataGrid-columnHeader': {
                            color: theme.palette.grey50.main,
                            fontSize: '0.6875rem',
                            fontWeight: 800,
                            letterSpacing: '0.07em',
                            lineHeight: 1.5,
                            padding: '0 0.25rem',
                            textTransform: 'uppercase'
                        },
                        '& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer': {
                            visibility: 'visible',
                            width: 'auto'
                        },
                        '& .MuiDataGrid-columnHeader--alignRight': {
                            textAlign: 'right'
                        },
                        '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon': {
                            opacity: '1 !important'
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 800
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            height: '100%'
                        },
                        '& .MuiDataGrid-columnHeadersInner': {
                            alignItems: 'center',
                            height: 'inherit'
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            display: 'none'
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: theme.palette.ghostWhite.main
                        },
                        '& .MuiIconButton-root': {
                            color: theme.palette.grey300.main
                        },
                        '& .MuiIconButton-root:hover': {
                            backgroundColor: 'transparent',
                            color: theme.palette.primary.main
                        },
                        '& .MuiTablePagination-displayedRows': {
                            color: theme.palette.grey100.main,
                            fontSize: '1rem',
                            marginBottom: 0
                        },
                        '& .MuiTablePagination-selectLabel': {
                            color: theme.palette.grey100.main,
                            fontSize: '1rem',
                            marginBottom: 0
                        },
                        '&.MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
                            borderBottom: '1px solid #f0f0f0'
                        },
                        '&.MuiDataGrid-row--editing': {
                            boxShadow: 'none'
                        },
                        border: 0,
                        color: theme.palette.grey100.main
                    };
                }
            }
        },
        MuiIconButton: {
            defaultProps: {
                disableFocusRipple: true
            },
            styleOverrides: {
                root: function(param) {
                    var ownerState = param.ownerState, theme = param.theme;
                    var _theme_palette_ownerState_color;
                    return {
                        '&:focus-visible': {
                            outline: "1px solid ".concat(((_theme_palette_ownerState_color = theme.palette[ownerState.color]) === null || _theme_palette_ownerState_color === void 0 ? void 0 : _theme_palette_ownerState_color.main) || theme.palette.primary.main),
                            outlineOffset: '2px'
                        }
                    };
                },
                sizeSmall: {
                    '& > svg': {
                        height: '0.75em',
                        width: '0.75em'
                    },
                    height: '0.75em',
                    width: '0.75em'
                }
            }
        },
        MuiInput: {
            styleOverrides: {
                input: {
                    textAlign: 'inherit'
                },
                root: function(param) {
                    var ownerState = param.ownerState, theme = param.theme;
                    var _obj;
                    return _obj = {
                        '& input::placeholder': {
                            color: theme.palette.grey300.main,
                            opacity: 1
                        },
                        '&:after': {
                            borderBottom: 0
                        },
                        '&:before': {
                            borderBottom: "1px dashed ".concat(ownerState['data-no-focus-style'] ? 'transparent !important' : theme.palette[ownerState.disabled ? 'grey600' : 'grey300'].main)
                        }
                    }, _define_property(_obj, "label+&.".concat(inputClasses.root), {
                        marginTop: 0
                    }), _define_property(_obj, "&:hover:not(.".concat(inputClasses.disabled, ", .").concat(inputClasses.error, ", .").concat(inputClasses.focused, "):before"), {
                        borderBottom: ownerState['data-no-focus-style'] ? "1px dashed transparent !important" : "1px dashed ".concat(theme.palette.primary.main)
                    }), _define_property(_obj, "&.".concat(inputClasses.focused, ":hover:before"), {
                        borderBottom: 0
                    }), _define_property(_obj, "&.".concat(inputClasses.focused), {
                        outline: ownerState['data-no-focus-style'] ? 'none' : "1px solid ".concat(theme.palette.primary.main)
                    }), _define_property(_obj, "&.".concat(inputClasses.focused, ":before"), {
                        borderBottom: 0
                    }), _define_property(_obj, "&.".concat(inputClasses.focused, ":after"), {
                        borderBottom: 0
                    }), _define_property(_obj, "backgroundColor", theme.palette[ownerState.disabled ? 'grey800' : 'white'].main), _define_property(_obj, "borderRadius", theme.spacing(0.5)), _define_property(_obj, "color", theme.palette[ownerState.disabled ? 'grey400' : 'primary'].main), _define_property(_obj, "marginBottom", 0), _define_property(_obj, "padding", theme.spacing(1, 2)), _obj;
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: palette.grey100.main,
                    fontWeight: 700,
                    marginBottom: 0,
                    position: 'relative',
                    transform: 'none',
                    whiteSpace: 'inherit',
                    zIndex: 0
                }
            }
        },
        MuiList: {
            defaultProps: {
                'data-component': 'list'
            }
        },
        MuiListItem: {
            defaultProps: {
                'data-component': 'listItem'
            }
        },
        MuiListItemButton: {
            defaultProps: {
                'data-component': 'listItemButton'
            }
        },
        MuiListSubheader: {
            defaultProps: {
                'data-component': 'listSubheader'
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: function(param) {
                    var theme = param.theme;
                    return {
                        '&.Mui-selected': {
                            '&:focus': {
                                backgroundColor: theme.palette.grey900.main
                            },
                            '&:hover': {
                                backgroundColor: theme.palette.grey900.main
                            },
                            backgroundColor: theme.palette.white.main,
                            color: theme.palette.primary.main,
                            fontWeight: 700
                        },
                        '&:focus': {
                            backgroundColor: theme.palette.grey900.main,
                            borderLeft: "4px solid ".concat(theme.palette.primary.main)
                        },
                        '&:hover': {
                            backgroundColor: theme.palette.grey900.main
                        },
                        backgroundColor: theme.palette.white.main,
                        borderBottomColor: theme.palette.grey600.main,
                        borderBottomStyle: 'dashed',
                        borderBottomWidth: 1,
                        borderLeft: '4px solid transparent',
                        color: theme.palette.grey100.main,
                        fontSize: '1rem',
                        fontWeight: 400,
                        lineHeight: '1.5',
                        margin: 0,
                        outline: 'none',
                        padding: 8,
                        userSelect: 'none'
                    };
                }
            }
        },
        MuiModal: {
            defaultProps: {
                'data-component': 'modal'
            }
        },
        MuiPaper: {
            defaultProps: {
                'data-component': 'paper'
            },
            styleOverrides: {
                elevation0: function(param) {
                    var theme = param.theme;
                    return {
                        '&.MuiCard-root': {
                            border: "".concat(theme.spacing(0.25), " solid ").concat(theme.palette.grey600.main)
                        }
                    };
                },
                // todo:: temporary workaround until we can get a valid shadow list from ux
                elevation1: function(param) {
                    var theme = param.theme;
                    return {
                        '&.MuiCard-root': {
                            boxShadow: theme.shadows[24]
                        }
                    };
                }
            }
        },
        MuiPopper: {
            defaultProps: {
                'data-component': 'popper'
            }
        },
        MuiRadio: {
            defaultProps: {
                disableFocusRipple: true
            },
            styleOverrides: {
                root: function(param) {
                    var ownerState = param.ownerState, theme = param.theme;
                    var _theme_palette_ownerState_color;
                    return {
                        '&.Mui-focusVisible': {
                            outline: "1px solid ".concat(((_theme_palette_ownerState_color = theme.palette[ownerState.color]) === null || _theme_palette_ownerState_color === void 0 ? void 0 : _theme_palette_ownerState_color.main) || theme.palette.primary.main),
                            outlineOffset: '2px'
                        },
                        padding: 0
                    };
                }
            }
        },
        MuiSkeleton: {
            defaultProps: {
                'data-component': 'skeleton'
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
                fontSizeLarge: {
                    height: '1.2em',
                    width: '1.2em'
                },
                fontSizeSmall: {
                    height: '0.85em',
                    width: '0.85em'
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                head: function(param) {
                    var theme = param.theme;
                    return {
                        color: theme.palette.grey50.main,
                        fontSize: '0.6875rem',
                        fontWeight: 800,
                        letterSpacing: '0.07em',
                        lineHeight: 1.5,
                        textTransform: 'uppercase'
                    };
                },
                root: {
                    '&[role="rowheader"]': {
                        fontWeight: 600
                    },
                    ':first-of-type': {
                        paddingLeft: '0.25rem'
                    },
                    ':last-of-type': {
                        paddingRight: '0.25rem'
                    },
                    fontSize: '1rem',
                    padding: '0.6875rem'
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    ':last-child:not(.MuiTableRow-head) .MuiTableCell-root': {
                        borderBottom: '1px solid transparent'
                    }
                }
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    lineHeight: '1.5',
                    padding: '0.5rem 0.25rem',
                    width: '3rem'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                arrow: {
                    '&::before': {
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)'
                    },
                    color: palette.white.main
                },
                tooltip: {
                    backgroundColor: palette.white.main,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
                    color: palette.grey300.main,
                    fontSize: '0.875rem',
                    fontWeight: 400,
                    padding: '0.75rem'
                }
            }
        },
        MuiTypography: {
            defaultProps: {
                'data-component': 'text'
            }
        },
        Navbar: {
            styleOverrides: {
                desktop: {
                    selected: 'rgb(250,250,250)',
                    unselected: 'rgb(242,242,242)'
                },
                mobile: {
                    selected: '#153850FF',
                    unselected: 'rgb(250,250,250)'
                }
            }
        }
    },
    palette: palette,
    shadows: [
        'none',
        '0px 2px 1px -1px rgba(114, 114, 114, 0.15),0px 1px 1px 0px rgba(114, 114, 114, 0.15),0px 1px 3px 0px rgba(114, 114, 114, 0.15)',
        '0px 3px 3px -2px rgba(114, 114, 114, 0.15),0px 3px 4px 0px rgba(114, 114, 114, 0.15),0px 1px 8px 0px rgba(114, 114, 114, 0.15)',
        '0px 3px 1px -2px rgba(114, 114, 114, 0.15),0px 2px 2px 0px rgba(114, 114, 114, 0.15),0px 1px 5px 0px rgba(114, 114, 114, 0.15)',
        '0px 2px 4px -1px rgba(114, 114, 114, 0.15),0px 4px 5px 0px rgba(114, 114, 114, 0.15),0px 1px 10px 0px rgba(114, 114, 114, 0.15)',
        '0px 3px 5px -1px rgba(114, 114, 114, 0.15),0px 5px 8px 0px rgba(114, 114, 114, 0.15),0px 1px 14px 0px rgba(114, 114, 114, 0.15)',
        '0px 3px 5px -1px rgba(114, 114, 114, 0.15),0px 6px 10px 0px rgba(114, 114, 114, 0.15),0px 1px 18px 0px rgba(114, 114, 114, 0.15)',
        '0px 4px 5px -2px rgba(114, 114, 114, 0.15),0px 7px 10px 1px rgba(114, 114, 114, 0.15),0px 2px 16px 1px rgba(114, 114, 114, 0.15)',
        '0px 5px 5px -3px rgba(114, 114, 114, 0.15),0px 8px 10px 1px rgba(114, 114, 114, 0.15),0px 3px 14px 2px rgba(114, 114, 114, 0.15)',
        '0px 5px 6px -3px rgba(114, 114, 114, 0.15),0px 9px 12px 1px rgba(114, 114, 114, 0.15),0px 3px 16px 2px rgba(114, 114, 114, 0.15)',
        '0px 6px 6px -3px rgba(114, 114, 114, 0.15),0px 10px 14px 1px rgba(114, 114, 114, 0.15),0px 4px 18px 3px rgba(114, 114, 114, 0.15)',
        '0px 6px 7px -4px rgba(114, 114, 114, 0.15),0px 11px 15px 1px rgba(114, 114, 114, 0.15),0px 4px 20px 3px rgba(114, 114, 114, 0.15)',
        '0px 7px 8px -4px rgba(114, 114, 114, 0.15),0px 12px 17px 2px rgba(114, 114, 114, 0.15),0px 5px 22px 4px rgba(114, 114, 114, 0.15)',
        '0px 7px 8px -4px rgba(114, 114, 114, 0.15),0px 13px 19px 2px rgba(114, 114, 114, 0.15),0px 5px 24px 4px rgba(114, 114, 114, 0.15)',
        '0px 7px 9px -4px rgba(114, 114, 114, 0.15),0px 14px 21px 2px rgba(114, 114, 114, 0.15),0px 5px 26px 4px rgba(114, 114, 114, 0.15)',
        '0px 8px 9px -5px rgba(114, 114, 114, 0.15),0px 15px 22px 2px rgba(114, 114, 114, 0.15),0px 6px 28px 5px rgba(114, 114, 114, 0.15)',
        '0px 8px 10px -5px rgba(114, 114, 114, 0.15),0px 16px 24px 2px rgba(114, 114, 114, 0.15),0px 6px 30px 5px rgba(114, 114, 114, 0.15)',
        '0px 8px 11px -5px rgba(114, 114, 114, 0.15),0px 17px 26px 2px rgba(114, 114, 114, 0.15),0px 6px 32px 5px rgba(114, 114, 114, 0.15)',
        '0px 9px 11px -5px rgba(114, 114, 114, 0.15),0px 18px 28px 2px rgba(114, 114, 114, 0.15),0px 7px 34px 6px rgba(114, 114, 114, 0.15)',
        '0px 9px 12px -6px rgba(114, 114, 114, 0.15),0px 19px 29px 2px rgba(114, 114, 114, 0.15),0px 7px 36px 6px rgba(114, 114, 114, 0.15)',
        '0px 10px 13px -6px rgba(114, 114, 114, 0.15),0px 20px 31px 3px rgba(114, 114, 114, 0.15),0px 8px 38px 7px rgba(114, 114, 114, 0.15)',
        '0px 10px 13px -6px rgba(114, 114, 114, 0.15),0px 21px 33px 3px rgba(114, 114, 114, 0.15),0px 8px 40px 7px rgba(114, 114, 114, 0.15)',
        '0px 10px 14px -6px rgba(114, 114, 114, 0.15),0px 22px 35px 3px rgba(114, 114, 114, 0.15),0px 8px 42px 7px rgba(114, 114, 114, 0.15)',
        '0px 11px 14px -7px rgba(114, 114, 114, 0.15),0px 23px 36px 3px rgba(114, 114, 114, 0.15),0px 9px 44px 8px rgba(114, 114, 114, 0.15)',
        '0 1px 3px #00000026' // shadow which is in use for all cards
    ],
    spacing: 4,
    typography: {
        a1: {
            fontSize: '3rem',
            fontWeight: 300,
            lineHeight: 1.2
        },
        a2: {
            fontSize: '3rem',
            fontWeight: 400,
            lineHeight: 1.2
        },
        allVariants: {
            marginBottom: '1rem'
        },
        b1: {
            fontSize: '2.5rem',
            fontWeight: 300,
            letterSpacing: '0.025rem',
            lineHeight: 1.15
        },
        b2: {
            fontSize: '2.5rem',
            fontWeight: 600,
            letterSpacing: '0.025rem',
            lineHeight: 1.15
        },
        c1: {
            fontSize: '2.0625rem',
            fontWeight: 400,
            letterSpacing: '0.02063rem',
            lineHeight: 1.15
        },
        c2: {
            fontSize: '2.0625rem',
            fontWeight: 600,
            letterSpacing: '0.02063rem',
            lineHeight: 1.15
        },
        d1: {
            fontSize: '1.6875rem',
            fontWeight: 400,
            letterSpacing: '0.01688rem',
            lineHeight: 1.15
        },
        d2: {
            fontSize: '1.6875rem',
            fontWeight: 700,
            letterSpacing: '0.01688rem',
            lineHeight: 1.15
        },
        e1: {
            fontSize: '1.5rem',
            fontWeight: 400,
            letterSpacing: '0.015rem',
            lineHeight: 1.25
        },
        e2: {
            fontSize: '1.5rem',
            fontWeight: 700,
            letterSpacing: '0.015rem',
            lineHeight: 1.25
        },
        f1: {
            fontSize: '1.1875rem',
            fontWeight: 400,
            letterSpacing: '0.01188rem',
            lineHeight: 1.4
        },
        f2: {
            fontSize: '1.1875rem',
            fontWeight: 700,
            letterSpacing: '0.01188rem',
            lineHeight: 1.4
        },
        fontFamily: [
            'Nunito Sans',
            'ui-sans-serif',
            'system-ui',
            '-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'Roboto',
            'Helvetica Neue',
            'Arial',
            'Noto Sans,sans-serif',
            'Apple Color Emoji',
            'Segoe UI Emoji',
            'Segoe UI Symbol',
            'Noto Color Emoji'
        ].join(','),
        fontSize: 13,
        g1: {
            fontSize: '1rem',
            fontWeight: 400,
            letterSpacing: '0.01rem',
            lineHeight: 1.36
        },
        g2: {
            fontSize: '1rem',
            fontWeight: 700,
            letterSpacing: '0.0075rem',
            lineHeight: 1.36
        },
        htmlFontSize: 13,
        i1: {
            fontFamily: 'Nunito Sans',
            fontSize: '0.875rem',
            fontWeight: 400,
            letterSpacing: '0.00875rem',
            lineHeight: 1.4
        },
        i2: {
            fontFamily: 'Nunito Sans',
            fontSize: '0.875rem',
            fontWeight: 700,
            letterSpacing: '0.00875rem',
            lineHeight: 1.4
        },
        j1: {
            fontFamily: 'Nunito Sans',
            fontSize: '0.75rem',
            fontWeight: 600,
            letterSpacing: '0.0075rem',
            lineHeight: 1.4
        },
        j2: {
            fontFamily: 'Nunito Sans',
            fontSize: '0.75rem',
            fontWeight: 700,
            letterSpacing: '0.015rem',
            lineHeight: 1.4
        },
        k3: {
            fontSize: '0.6875rem',
            fontWeight: 800,
            letterSpacing: '0.055rem',
            lineHeight: 1.45,
            textTransform: 'uppercase'
        }
    }
});
export var MaterialThemeProvider = /*#__PURE__*/ memo(function(_param) {
    var _param_themeOverrides = _param.themeOverrides, themeOverrides = _param_themeOverrides === void 0 ? {} : _param_themeOverrides, props = _object_without_properties(_param, [
        "themeOverrides"
    ]);
    var _whitelabel_data;
    var whitelabel = useGetWhiteLabel({
        query: {
            enabled: !!props.isWhitelabeled,
            keepPreviousData: true,
            useErrorBoundary: false
        }
    });
    var muiTheme = useMemo(function() {
        var _whitelabel_data, _whitelabel_data1;
        return _object_spread({}, merge(theme, !!props.isWhitelabeled && ((_whitelabel_data = whitelabel.data) === null || _whitelabel_data === void 0 ? void 0 : _whitelabel_data.theme) ? (_whitelabel_data1 = whitelabel.data) === null || _whitelabel_data1 === void 0 ? void 0 : _whitelabel_data1.theme : themeOverrides));
    }, [
        (_whitelabel_data = whitelabel.data) === null || _whitelabel_data === void 0 ? void 0 : _whitelabel_data.theme,
        props.isWhitelabeled,
        themeOverrides
    ]);
    return /*#__PURE__*/ _jsx(ThemeProvider, {
        theme: muiTheme,
        children: props.children
    });
});
MaterialThemeProvider.displayName = 'MaterialThemeProvider';

//# sourceMappingURL=MaterialProvider.js.map